import {Image, Name} from './index';
import {Page, PageIdentity} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';
import {JsonClassType, JsonProperty, ObjectMapper} from '@outfoxx/jackson-js';
import {JsonClassTypeOptions, JsonParserContext} from '@outfoxx/jackson-js/dist/@types';
import {HasNameInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/HasNameInterface';
import {Sort} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';
import {UrlProviderInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/UrlProviderInterface';
import {Filters} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter';

export class Category implements HasNameInterface, UrlProviderInterface {
    private static _ALLOWED_SORT = [
        new Sort('По возрастанию', 'sort', 'asc', true),
        new Sort('По убыванию', 'sort', 'desc'),
        new Sort('По названию (А-Я)', 'name', 'asc'),
        new Sort('По названию (Я-А)', 'name', 'desc'),
    ];

    @JsonProperty()
    id: string;
    @JsonProperty()
    image: Image;
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> {type: () => [Name]})
    name: Name;
    @JsonProperty()
    description: string;
    @JsonProperty()
    countPages: number;
    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions> {type: () => [Array, [Page]]})
    pages: Page[];

    @JsonProperty()
    seo: object;

    @JsonProperty()
    dateCreate: number;
    @JsonProperty()
    dateUpdate: number;

    private _sortMode: Sort = Category._ALLOWED_SORT[0];

    public static createByObj(object: object | null): Category {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<Category>(JSON.stringify(object), {mainCreator: () => [Category]} as JsonParserContext);
    }

    public findPageByIdentity(identity: PageIdentity): Page|null {
        if (this.name.urlName !== identity.categoryUrlName) {
            return null;
        }
        for (const page of this.pages) {
            if (page.identity.equals(identity)) {
                return page;
            }
        }

        return null;
    }

    get allowedSortModes(): Sort[] {
        return Category._ALLOWED_SORT;
    }


    get sortMode(): Sort {
        if (!this._sortMode) {
            this._sortMode = Category._ALLOWED_SORT[0];
        }

        return this._sortMode;
    }

    set sortMode(value: Sort) {
        this._sortPages(value);
        this._sortMode = value;
    }

    get filters(): Filters {
        return new Filters();
    }

    private _sortPages(sort: Sort) {
        const _sort = sort.value == 'asc' ? 1 : -1;

        this.pages = this.pages.sort((p1: Page, p2: Page) => {
            if (p1[sort.field] > p2[sort.field]) {
                return _sort;
            }
            if (p1[sort.field] < p2[sort.field]) {
                return _sort * -1;
            }

            return 0;
        });
    }

    public getUrl(): any {
        return {name: 'category', params: {categoryUrlName: this.name.urlName}};
    }

    public getMapUrl() {
        return {name: 'category-map', params: {categoryUrlName: this.name.urlName}};
    }
}
